import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import { FixedImage } from 'components/NextImage'

import classes from './Media.module.scss'

/** @type {import("./types").default} */
const Media = ({ screenshot, onClick, orientation, className, loading, imageProps }) => {
  const isVideo = !!screenshot?.thumbnail

  return (
    <div
      data-testid="carouselMedia"
      className={clsx('Carousel_Media', classes.root, className)}
      onClick={onClick}
      role="link"
    >
      <FixedImage
        fetchWidth={300}
        className={orientation === 'horizontal' ? classes.carouselImageH : classes.carouselImageV}
        src={isVideo ? screenshot.thumbnail : screenshot.url}
        alt="Feature image"
        loading={loading}
        {...imageProps}
      />
      {isVideo && <Icon icon="play-circle" prefix="far" className={classes.playIcon} />}
    </div>
  )
}

export default Media
